import React from 'react';
import { Table, TableBody } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { AppState } from 'services/types';
import { createStructuredSelector } from 'reselect';

// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import {
    WorksheetPageIndex,
    SprayWorksheetEntitySummary
} from 'services/worksheet/types';
import PrintSprayWorksheetCompletionDetailsTableHeader from './components/PrintSprayWorksheetCompletionDetailsTableHeader';
import PrintSprayWorksheetCompletionDetailsTableRow from './components/PrintSprayWorksheetCompletionDetailsTableRow';
import PrintSprayWorksheetCompletionDetailsTableSummary from './components/PrintSprayWorksheetCompletionDetailsTableSummary';
import { makeSelectSprayWorksheetEntitySummaries } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

interface ConnectedProps {
    entitySummaries: SprayWorksheetEntitySummary[];
}

type Props = OwnProps & ConnectedProps;

export class PrintSprayWorksheetCompletionDetailsTableComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { pageIndex, entitySummaries } = this.props;

        return (
            <ResponsiveTable>
                <Table basic="very" className="basic-table" unstackable>
                    <PrintSprayWorksheetCompletionDetailsTableHeader />
                    <TableBody>
                        {entitySummaries &&
                            entitySummaries.map((entitySummary, index) => (
                                <PrintSprayWorksheetCompletionDetailsTableRow
                                    entitySummaryIndex={index}
                                    pageIndex={pageIndex}
                                    key={index} // eslint-disable-line react/no-array-index-key
                                />
                            ))}
                    </TableBody>
                    <PrintSprayWorksheetCompletionDetailsTableSummary
                        pageIndex={pageIndex}
                    />
                </Table>
            </ResponsiveTable>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entitySummaries: makeSelectSprayWorksheetEntitySummaries()
});

export default connect(mapStateToProps)(
    PrintSprayWorksheetCompletionDetailsTableComponent
);
